import { styled } from 'styled-components';
import { SPText } from '~/components/styles/styles';
import { classic } from '~/themes';

type IProps = {};

type TProps = IProps;

export function RulesClassementContent({}: TProps) {
  return (
    <Container>
      <SPText>{`Les joueurs sont classés du plus haut pourcentage de réussite au plus bas.`}</SPText>

      <SPText>{`Si deux utilisateurs sont à égalité, le classement se calcule en fonction : `}</SPText>
      <SOl>
        <li>1. Du nombre de thématiques lancées.</li>
        <li>2. Du nombre de tentatives réalisées sur le dernier quiz.</li>
      </SOl>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SOl = styled.ol<{
  $color?: string;
  $textAlign?: string;
  $margin?: string;
}>`
  color: ${({ $color }) => ($color ? $color : `${classic.token?.colorText}`)};
  font-family: 'Fira Sans', serif;
  font-weight: 400;
  font-size: 1.1rem;
  text-align: ${({ $textAlign }) => ($textAlign ? $textAlign : 'left')};
  margin: ${({ $margin }) => ($margin ? $margin : '0')};

  @media screen and (max-height: 800px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 450px) {
    font-size: 1rem;
  }
  & > li {
    list-style: none;
  }
`;
